import axios from "axios";
import store from "./store";

const checkAuth = () => {
  /*  Token is stored in Redux memory only (never localStorage).
    On initial load, if there is no token in Redux, PersistLogin will attempt
    a silent refresh. Public routes are always accessible.  */
  const PUBLIC_ROUTES = [
    "login",
    "forgot-password",
    "register",
    "documentation",
  ];

  const isPublicPage = PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r),
  );

  if (!isPublicPage) {
    // Set up axios interceptors — token is read dynamically from Redux store on every request
    axios.interceptors.request.use(
      function (config) {
        document.body.classList.add("loading-indicator");
        const token = store.getState().auth.token;
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      function (response) {
        document.body.classList.remove("loading-indicator");
        return response;
      },
      function (error) {
        document.body.classList.remove("loading-indicator");
        return Promise.reject(error);
      },
    );
  }
};

export default checkAuth;
